<footer class="mt-5">
  <hr class="m-0" />
  <div class="text-muted p-4 text-center">
    <span class="me-1">{{ "footerCustomerSupportLabel" | localize }}:</span>
    <span class="me-1">{{ "footerCustomerSupportPhoneLabel" | localize }} {{ customerSupportInfo.phone }},</span>
    <a href="mailto:{{ customerSupportInfo.email }}">{{ customerSupportInfo.email }}</a>
  </div>
</footer>
